"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deletePO = exports.revokePO = exports.getPOReducer = void 0;
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var usersList_1 = require("common/global/usersList");
var doesObjHaveUndefinedValues_1 = __importDefault(require("common/utils/doesObjHaveUndefinedValues"));
var removeUndefined_1 = __importDefault(require("common/utils/removeUndefined"));
var app_1 = __importStar(require("firebase/app"));
var lodash_1 = require("lodash");
var set_1 = __importDefault(require("lodash/fp/set"));
var moment_1 = __importDefault(require("moment"));
var sendApprovalNotification_1 = require("portal/utils/sendApprovalNotification");
var SendNotification_1 = require("portal/utils/SendNotification");
var PRReducer_1 = require("../PR/PRReducer");
var currenciesList_1 = require("common/global/currenciesList");
var getPOReducer = function (router, t) { return function (state, action) {
    var _a, _b, _c, _d;
    var userId = (_b = (_a = (0, app_1.auth)().currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : "";
    switch (action.type) {
        case "init":
            return action.payload;
        case "update":
            if (action.payload.path === "POData.PODate") {
                var isBefore = (0, moment_1.default)(action.payload.newValue).isBefore((_c = state.CBAData.CBADate) === null || _c === void 0 ? void 0 : _c.toDate());
                if (isBefore) {
                    antd_1.message.error("PO Date can not be before CBA Date");
                }
                var newDate = isBefore
                    ? (_d = state.CBAData.CBADate) === null || _d === void 0 ? void 0 : _d.toDate()
                    : action.payload.newValue;
                return (0, set_1.default)(action.payload.path, newDate, state);
            }
            return (0, set_1.default)(action.payload.path, action.payload.newValue, state);
        case "buttonClick":
            switch (action.data.action) {
                case "Approve": {
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    transaction.set(collectionsRef_1.approvalsRef.doc(), {
                                        approvedAt: action.data.payload.approvedAt,
                                        createdAt: new Date(),
                                        updatedAt: new Date(),
                                        userId: userId,
                                        formId: state.POId,
                                        formType: "purchase-order",
                                        approvalType: action.data.payload.approvalType,
                                        signatureURL: (_b = (_a = usersList_1.globalUsersData[userId]) === null || _a === void 0 ? void 0 : _a.signatureURL) !== null && _b !== void 0 ? _b : "",
                                    });
                                    return [4 /*yield*/, checkIfAllApproved(state.POId, state.POData.orderId, state, userId, action.data.payload.approvalType, transaction)];
                                case 1:
                                    _c.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () {
                        antd_1.message.success(t("alerts.success"));
                        //   window.location.reload();
                    })
                        .catch(function (error) {
                        antd_1.message.error(error);
                    });
                    var nextStatus = checkNextStatus(state, action.data.payload.approvalType);
                    return __assign(__assign({}, state), { POData: __assign(__assign({}, state.POData), { status: nextStatus }) });
                    //   break;
                }
                case "Save": {
                    app_1.default.firestore().runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            transaction.update(collectionsRef_1.POsRef.doc(state.POId), (0, removeUndefined_1.default)(getPODataFromState(state)));
                            state.POItems.map(function (item) {
                                transaction.update(collectionsRef_1.POItemsRef.doc(item.id), (0, removeUndefined_1.default)(getPOItemsFromState(item)));
                            });
                            return [2 /*return*/];
                        });
                    }); });
                    collectionsRef_1.POsRef.doc(state.POId)
                        .update((0, removeUndefined_1.default)(getPODataFromState(state)))
                        .then(function () {
                        antd_1.message.success(t("alerts.success"));
                    });
                    break;
                }
                case "Cancel": {
                    collectionsRef_1.POsRef.doc(state.POId)
                        .update({ status: "cancelled" })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                                        warehouseId: state.POData.deliverToWarehouseId,
                                        projectId: state.POData.projectId,
                                        docType: "purchase-order",
                                        docId: state.POId,
                                        ref: (_a = state.POData.PONumber) !== null && _a !== void 0 ? _a : "",
                                        docDesc: "",
                                        action: "cancelled",
                                    })
                                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, antd_1.message.success(t("alerts.success"))];
                                                case 1:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); })
                                        .then(function () {
                                        window.location.reload();
                                    })];
                                case 1:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    break;
                }
                case "Publish": {
                    var poData_1 = __assign({}, getPODataFromState(state));
                    if ((0, doesObjHaveUndefinedValues_1.default)(__assign({}, poData_1))) {
                        antd_1.message.error(t("alerts.invalidFormMsg"));
                        return __assign(__assign({}, state), { triedSubmitting: true });
                    }
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestedBy, productsIds;
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    if (!!(0, doesObjHaveUndefinedValues_1.default)(poData_1)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, collectionsRef_1.IRsRef.where("orderId", "==", poData_1.orderId).get()];
                                case 1:
                                    requestedBy = (_b = (_a = (_c.sent()).docs[0]) === null || _a === void 0 ? void 0 : _a.data()) === null || _b === void 0 ? void 0 : _b.requestedBy;
                                    transaction.update(collectionsRef_1.POsRef.doc(state.POId), __assign(__assign({}, poData_1), { requestedAt: new Date(), requestedBy: requestedBy, status: "pendingPoFinanceProjectsManagerApproval" }));
                                    state.POItems.map(function (item) {
                                        transaction.update(collectionsRef_1.POItemsRef.doc(item.id), (0, removeUndefined_1.default)(getPOItemsFromState(item)));
                                    });
                                    _c.label = 2;
                                case 2:
                                    productsIds = state.POItems.map(function (e) {
                                        return transaction.update(collectionsRef_1.suppliersRef.doc(state.POData.supplierId), {
                                            productsIds: [e.productId],
                                        });
                                    });
                                    productsIds;
                                    state.POItems.map(function (e) {
                                        return transaction.update(collectionsRef_1.productsRef.doc(e.productId), {
                                            supplierIds: [state.POData.supplierId],
                                        });
                                    });
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, (0, sendApprovalNotification_1.sendApprovalNotification)({
                                        warehouseId: state.POData.deliverToWarehouseId,
                                        approval: "POFinanceProjectsManagerApproval",
                                        projectId: state.POData.projectId,
                                        amount: (_a = state.POData.overallTotal) !== null && _a !== void 0 ? _a : 0,
                                        docId: state.POId,
                                        docType: "purchase-order",
                                        ref: state.POData.PONumber,
                                        userId: userId,
                                        docDesc: "",
                                        action: "approvalPending",
                                    })
                                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, antd_1.message.success(t("alerts.success"))];
                                                case 1:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); })
                                        .then(function () {
                                        window.location.reload();
                                    })];
                                case 1:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () { })
                        .catch(function (e) {
                        console.error(e);
                        antd_1.message.error(t("alerts.error"));
                    });
                    break;
                }
                case "Revoke": {
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, (0, exports.revokePO)(state.POId, state.POData.orderId, transaction)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                                        warehouseId: state.POData.deliverToWarehouseId,
                                        projectId: state.POData.projectId,
                                        docType: "purchase-order",
                                        docId: state.POId,
                                        ref: (_a = state.POData.PONumber) !== null && _a !== void 0 ? _a : "",
                                        docDesc: "",
                                        action: "revoked",
                                    })];
                                case 1:
                                    _b.sent();
                                    antd_1.message.success(t("alerts.success"));
                                    window.location.reload();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .catch(function (e) {
                        antd_1.message.error(e);
                    });
                    break;
                }
            }
    }
    return state;
}; };
exports.getPOReducer = getPOReducer;
var getPODataFromState = function (state) {
    var _a, _b;
    return __assign(__assign({}, state.POData), { PODate: (_b = (_a = state.POData.PODate) === null || _a === void 0 ? void 0 : _a.toDate()) !== null && _b !== void 0 ? _b : undefined, taxes: state.RFQData.taxes, shippingCosts: state.RFQData.shippingCosts, overallTotal: (0, lodash_1.sumBy)(state.POItems, function (i) { return i.totalPrice; }) +
            (state.POData.shippingCosts === "included" ||
                state.POData.shippingCosts === ""
                ? 0
                : state.POData.shippingCosts) +
            (state.POData.taxes === "included" || state.POData.taxes === ""
                ? 0
                : state.POData.taxes), currencyId: state.POData.currencyId });
};
var getPOItemsFromState = function (item) {
    return {
        orderedItem: item.orderedItem,
    };
};
function checkIfAllApproved(POId, orderId, state, userId, approvalType, transaction) {
    return __awaiter(this, void 0, void 0, function () {
        var waitingFor, overallTotalInDollar, _a;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    overallTotalInDollar = state.POData.overallTotal / state.RFQData.exchangeRate;
                    if (!(approvalType === "generalDirector")) return [3 /*break*/, 2];
                    transaction.update(collectionsRef_1.POsRef.doc(POId), { status: "approved" });
                    transaction.update(collectionsRef_1.ordersRef.doc(state.POData.orderId), {
                        status: "postPOs",
                    });
                    return [4 /*yield*/, Promise.all(state.POItems.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                            var product, currency, newProductCost;
                            var _a, _b, _c, _d, _e;
                            return __generator(this, function (_f) {
                                switch (_f.label) {
                                    case 0: return [4 /*yield*/, collectionsRef_1.productsRef.doc((_a = item.orderedItem.id) !== null && _a !== void 0 ? _a : item.productId).get()];
                                    case 1:
                                        product = (_f.sent()).data();
                                        currency = (_c = currenciesList_1.globalCurrenciesData[(_b = state.currencyId) !== null && _b !== void 0 ? _b : ""]) === null || _c === void 0 ? void 0 : _c.name;
                                        newProductCost = currency == "TRY (TL)"
                                            ? item.unitPrice / state.RFQData.exchangeRate
                                            : item.unitPrice;
                                        return [2 /*return*/, transaction.update(collectionsRef_1.productsRef.doc((_d = item.orderedItem.id) !== null && _d !== void 0 ? _d : item.productId), {
                                                previousCost: newProductCost,
                                                averageCost: product.averageCost
                                                    ? (product.averageCost * product.numberOfPurchases +
                                                        newProductCost) /
                                                        (product.numberOfPurchases + 1)
                                                    : newProductCost,
                                                numberOfPurchases: ((_e = product.numberOfPurchases) !== null && _e !== void 0 ? _e : 0) + 1,
                                            })];
                                }
                            });
                        }); }))];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 7];
                case 2:
                    if (!(approvalType === "deputyGeneralDirector")) return [3 /*break*/, 6];
                    if (!(1000 > overallTotalInDollar)) return [3 /*break*/, 4];
                    transaction.update(collectionsRef_1.POsRef.doc(POId), { status: "approved" });
                    transaction.update(collectionsRef_1.ordersRef.doc(state.POData.orderId), {
                        status: "postPOs",
                    });
                    return [4 /*yield*/, Promise.all(state.POItems.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                            var product, currency, newProductCost;
                            var _a, _b, _c, _d, _e;
                            return __generator(this, function (_f) {
                                switch (_f.label) {
                                    case 0: return [4 /*yield*/, collectionsRef_1.productsRef.doc((_a = item.orderedItem.id) !== null && _a !== void 0 ? _a : item.productId).get()];
                                    case 1:
                                        product = (_f.sent()).data();
                                        currency = (_c = currenciesList_1.globalCurrenciesData[(_b = state.currencyId) !== null && _b !== void 0 ? _b : ""]) === null || _c === void 0 ? void 0 : _c.name;
                                        newProductCost = currency == "TRY (TL)"
                                            ? item.unitPrice / state.RFQData.exchangeRate
                                            : item.unitPrice;
                                        return [2 /*return*/, transaction.update(collectionsRef_1.productsRef.doc((_d = item.orderedItem.id) !== null && _d !== void 0 ? _d : item.productId), {
                                                previousCost: newProductCost,
                                                averageCost: product.averageCost
                                                    ? (product.averageCost * product.numberOfPurchases +
                                                        newProductCost) /
                                                        (product.numberOfPurchases + 1)
                                                    : newProductCost,
                                                numberOfPurchases: ((_e = product.numberOfPurchases) !== null && _e !== void 0 ? _e : 0) + 1,
                                            })];
                                }
                            });
                        }); })).catch(function (e) { return console.log(e); })];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    transaction.update(collectionsRef_1.POsRef.doc(POId), {
                        status: "pendingPoGeneralDirectorApproval",
                    });
                    waitingFor = "POGeneralDirectorApproval";
                    _b.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    if (approvalType === "financeProjectsManager") {
                        transaction.update(collectionsRef_1.POsRef.doc(POId), {
                            status: "pendingPoDeputyGeneralDirectorApproval",
                        });
                        waitingFor = "PODeputyGeneralDirectorApproval";
                    }
                    _b.label = 7;
                case 7:
                    if (!(approvalType !== "generalDirector")) return [3 /*break*/, 9];
                    return [4 /*yield*/, (0, sendApprovalNotification_1.sendApprovalNotification)({
                            warehouseId: state.POData.deliverToWarehouseId,
                            approval: waitingFor !== null && waitingFor !== void 0 ? waitingFor : "",
                            projectId: state.POData.projectId,
                            amount: state.POData.overallTotal,
                            docId: POId,
                            docType: "purchase-order",
                            ref: state.POData.PONumber,
                            userId: state.requestedBy,
                            docDesc: "",
                            action: "approvalPending",
                        })];
                case 8:
                    _a = _b.sent();
                    return [3 /*break*/, 10];
                case 9:
                    _a = null;
                    _b.label = 10;
                case 10:
                    _a;
                    return [2 /*return*/];
            }
        });
    });
}
function checkNextStatus(state, approvalType) {
    var status;
    var overallTotalInDollar = state.POData.overallTotal / state.RFQData.exchangeRate;
    if (approvalType === "generalDirector") {
        status = "approved";
    }
    else if (approvalType === "deputyGeneralDirector") {
        if (1000 > overallTotalInDollar) {
            status = "approved";
        }
        else {
            status = "pendingPoGeneralDirectorApproval";
        }
    }
    else if (approvalType === "financeProjectsManager") {
        status = "pendingPoDeputyGeneralDirectorApproval";
    }
    return status;
}
var revokePO = function (POId, orderId, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var PRs, someCompletedPR, itemsReceived, _a, _b, _c, _d;
    var _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0: return [4 /*yield*/, collectionsRef_1.PRsRef.where("POId", "==", POId).get()];
            case 1:
                PRs = (_e = (_f.sent()).docs) !== null && _e !== void 0 ? _e : [];
                someCompletedPR = PRs.some(function (x) {
                    var data = x.data();
                    return data.status === "singedAndArchived" || data.status === "completed";
                });
                if (someCompletedPR) {
                    throw new Error("you cannot revoke singed form");
                }
                return [4 /*yield*/, collectionsRef_1.DNsRef.where("orderId", "==", orderId).get()];
            case 2:
                itemsReceived = (_f.sent())
                    .docs.length;
                if (itemsReceived) {
                    throw new Error("This PO has Delivery Note and cannot be revoked");
                }
                return [4 /*yield*/, Promise.all(PRs.map(function (PRId) { return (0, PRReducer_1.deletePR)(PRId.id, transaction); }))];
            case 3:
                _f.sent();
                transaction.update(collectionsRef_1.POsRef.doc(POId), {
                    status: "draft",
                });
                transaction.update(collectionsRef_1.ordersRef.doc(orderId), { status: "preparingPOs" });
                _b = (_a = Promise).all;
                return [4 /*yield*/, collectionsRef_1.approvalsRef.where("formId", "==", POId).get()];
            case 4: return [4 /*yield*/, _b.apply(_a, [(_f.sent()).docs.map(function (x) {
                        return transaction.delete(x.ref);
                    })])];
            case 5:
                _f.sent();
                _d = (_c = Promise).all;
                return [4 /*yield*/, collectionsRef_1.notificationsRef.where("docId", "==", POId).get()];
            case 6: return [4 /*yield*/, _d.apply(_c, [(_f.sent()).docs.map(function (x) {
                        return transaction.delete(x.ref);
                    })])];
            case 7:
                _f.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.revokePO = revokePO;
var deletePO = function (POId, orderId, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, collectionsRef_1.POsRef.doc(POId).get()];
            case 1:
                data = (_a.sent()).data();
                if (data.status === "singedAndArchived" || data.status === "completed") {
                    throw new Error("you cannot delete singed form");
                }
                if (!(data.status === "pendingApprovals" || data.status === "approved")) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, exports.revokePO)(POId, orderId, transaction)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                transaction.delete(collectionsRef_1.POsRef.doc(POId));
                return [4 /*yield*/, collectionsRef_1.POItemsRef.where("POId", "==", POId).get()];
            case 4:
                (_a.sent()).docs.map(function (x) {
                    return transaction.delete(x.ref);
                });
                return [2 /*return*/];
        }
    });
}); };
exports.deletePO = deletePO;
